module.exports = __webpack_public_path__ + "img/btn-azimuthal-grid.74d62507.svg";